import React from "react";
import style from "../../styles/instructionview";

export default (props) => {
  return (
    <div>
      {props.value && (
        <div style={style.labelItem}>
          <label style={props.lblStyle}>{props.label}</label>
          {props.value}
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/InstructionAttribute.js